import React, { Component } from "react";

export default class plusIcon extends Component {
  render() {
    return (
      <svg
      className={this.props.className}
      onClick={this.props.onClick}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.10744 10.4629L15.8926 10.4629"
          stroke="#005EEF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 16.3555L10 4.57035"
          stroke="#005EEF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}
